// extracted by mini-css-extract-plugin
export default {"name":"ProfileItem_name__AAYzu","nameWrapper":"ProfileItem_nameWrapper__S0DDP","infoWrapper":"ProfileItem_infoWrapper__Aig5q"};